import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';
import { membershipStatusDefinitionsClient } from '~/services';
import type { MembershipStatusDefinitionType } from '~/services/membershipStatusDefinitions/membershipStatusDefinitionsClient.types';
import { useToasted } from '~/composables/useToasted';
import { catchRequestError } from '~/utils/request';

export const useMembershipStatusDefinitions = createGlobalState(() => {
    const toasted = useToasted();
    const teamId = Spark.state.currentTeam.id;
    const definitions = ref<MembershipStatusDefinitionType[] | undefined>(undefined);
    const loading = ref(false);

    const fetchDefinitions = async (): Promise<void> => {
        if (loading.value || definitions.value !== undefined) {
            return;
        }
        loading.value = true;
        try {
            const response = await membershipStatusDefinitionsClient.getMembershipStatusDefinitions({ teamId });
            definitions.value = response.data.definitions;
        } catch (err) {
            toasted.error(catchRequestError(err));
            definitions.value = [];
        } finally {
            loading.value = false;
        }
    };

    return { definitions, loading, fetchDefinitions };
});
